window.__webpack_public_path__ = "/";
fetch('./runtime-config.json').then((res)=>res.json()).then((config)=>{
    console.log(config,"config data");
    if(config.context){
        window.__webpack_public_path__ = config.context || "/";
    }
    window.__context__ = config.context;
    import("./bootstrap");
}).catch((err)=>{
    console.warn("Could not load runtime config :",err)
    import("./bootstrap");
})
export{}